import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import CertificationTestExecutionListScheduled from './CertificationTestExecutionListScheduled';
import CertificationTestExecutionListService from '../services/CertificationTestExecutionListService';

class CertificationTestExecutionListScheduledContainer extends Component {
  certificationTestListService = new CertificationTestExecutionListService();

  componentDidMount() {
    this.certificationTestListService.init('scheduled');
  }

  render() {
    return (
      <CertificationTestExecutionListScheduled
        certificationTests={toJS(this.certificationTestListService.certificationTests)}
        fetching={this.certificationTestListService.fetch.fetching}
        onLoad={this.certificationTestListService.load}
        onChange={this.certificationTestListService.handleChange}
        pagination={this.certificationTestListService.pagination}
      />
    );
  }
}

export default observer(CertificationTestExecutionListScheduledContainer);
